<div>

  <br/>
  <br/>
  <br/>
  <br/>
  <br/>

  <!-- Clear filter -->
  <div class="section-clear-filters">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="text-center">
            <h2>Oops, there's nothing left!</h2>
            <p>Try <a class="underline" (click)="clearFilters()"><strong>clearing your filters.</strong></a></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>
  <br/>
  <br/>

  <!-- Nominate -->
  <div class="section-nominate">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="nominate-panel">
            <div class="row">
              <div class="col-2">
                <div class="text-center">
                  <picture>
                    <source srcset="/images/conference-room/room-list/room-list-empty/globe-icon.webp" type="image/webp">
                    <img src="/images/conference-room/room-list/room-list-empty/globe-icon.png" height="50px" alt="Globe icon"/>
                  </picture>
                </div>
              </div>
              <div class="col-10">
                <h4 class="circular">Where should we go next?</h4>
                <p>
                  Do you know of any spaces in cities that should be next on our radar?
                  <a class="underline" href="https://bit.ly/2j8iHVf" target="_blank"><strong>Let us know here!</strong></a>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

</div>
